import { mapActions, mapGetters } from 'vuex';

import { STATUS_MAP } from 'shared/constants/statusMap.js';

import idleMixin from './idleMixin';

export default {
  mixins: [idleMixin],
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    enabledFeatures() {
      return this.account.features;
    },
  },
  methods: {
    ...mapActions('accounts', ['logActivity']),
    addAccountScoping(url) {
      return `/app/accounts/${this.accountId}/${url}`;
    },
    onOnline() {
      this.logActivity({
        accountId: this.accountId,
        status: STATUS_MAP.ONLINE,
      });
    },
    onBusy() {
      this.logActivity({
        accountId: this.accountId,
        status: STATUS_MAP.BUSY,
      });
    },
    onOffline() {
      this.logActivity({
        accountId: this.accountId,
        status: STATUS_MAP.OFFLINE,
      });
    },
  },
};
